"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMetadata = exports.handlePendoTracking = exports.handleHqOTracking = void 0;
const jwt_decode_1 = require("jwt-decode");
const axios_1 = require("axios");
const handleHqOTracking = (clientApiUrl, authToken, eventType, metadata) => {
    const { building_uuid, app_uuid, user_agent, type, timestamp } = metadata, rest = __rest(metadata, ["building_uuid", "app_uuid", "user_agent", "type", "timestamp"]);
    const { user_uuid } = (0, jwt_decode_1.default)(authToken);
    axios_1.default.post(`${clientApiUrl}/api/analytics/v2/tracking/track`, {
        type,
        eventType,
        timestamp,
        userUuid: user_uuid,
        appUuid: app_uuid,
        buildingUuid: building_uuid,
        userAgent: user_agent,
        properties: Object.assign({}, rest),
    }, {
        headers: {
            'hqo-building-uuid': building_uuid,
            'hqo-app-id': app_uuid,
            'Authorization': `${authToken}`,
        },
    });
};
exports.handleHqOTracking = handleHqOTracking;
const handlePendoTracking = (eventName, metadata) => {
    const { pendo } = window;
    if (!pendo) {
        console.warn('Pendo is not on the window object');
        return;
    }
    if (!pendo.track) {
        console.warn('Track is not in the pendo object');
        return;
    }
    if (pendo.track) {
        pendo.track(eventName, metadata);
    }
};
exports.handlePendoTracking = handlePendoTracking;
const validateMetadata = (metadata) => {
    const requiredFields = ['building_uuid', 'app_uuid', 'user_agent', 'type'];
    let isValid = true;
    requiredFields.forEach((field) => {
        if (!metadata[field]) {
            console.warn(`Missing the following field in metadata: "${field}"`);
            isValid = false;
        }
        if (field === 'type') {
            const eventTypes = ['action', 'impression'];
            if (!eventTypes.includes(metadata.type)) {
                console.warn(`Event type must be "action" or "impression". Invalid type: "${metadata.type}"`);
                isValid = false;
            }
        }
    });
    return isValid;
};
exports.validateMetadata = validateMetadata;
//# sourceMappingURL=utils.js.map